import './App.css';
import { Route, Routes, BrowserRouter as Router } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard';
import Category from './pages/category';
import Products from './pages/products';
import Services from './pages/services';
import Orders from './pages/orders';
import Customers from './pages/customers';
import Coupons from './pages/coupons';
// import SoldProducts from './pages/reports/SoldProducts';
// import ProductViewed from './pages/reports/ProductViewed';
import ProtectedRoutes from './routes/ProtectedRoutes';
import Reports from './pages/reports';
import { useEffect } from 'react';
import { handleLogoutFromServer } from './apis/logout';
import IdleTimer from "./helper/idleTimer";
import { useNavigate } from 'react-router-dom'
import { IDLE_TIME_IN_SECONDS } from './config';
import Blogs from './pages/blogs';
import AddProduct from './pages/products/AddProduct';
import Taxes from './pages/taxes';
import Brands from './pages/brands';
import Frames from './pages/frames';
import EditProduct from './pages/products/EditProduct';
import Lens from './pages/lens';
import LensSize from './pages/lensSize';
import LenSizeMapping from './pages/lensSizeMapping';
import { Toaster } from 'react-hot-toast'
import Filters from './pages/filters';
import BulkOrders from './pages/bulk-orders';
import SpecialCustomers from './pages/special-customers';

const queryClient = new QueryClient()
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster/>
      <Router>
        <Routes>
          <Route path='/login' exact element={<Login />} />
          <Route path='/' exact element={<ProtectedRoutes><Dashboard /></ProtectedRoutes>} />
          <Route path='/category' exact element={<ProtectedRoutes><Category /></ProtectedRoutes>} />
          <Route path='/products' exact element={<ProtectedRoutes><Products /></ProtectedRoutes>} />
          <Route path='/products/add-product' exact element={<ProtectedRoutes><AddProduct /></ProtectedRoutes>} />
          <Route path='/products/:id' exact element={<ProtectedRoutes><EditProduct /></ProtectedRoutes>} />
          <Route path='/services' exact element={<ProtectedRoutes><Services /></ProtectedRoutes>} />
          <Route path='/orders' exact element={<ProtectedRoutes><Orders /></ProtectedRoutes>} />
          <Route path='/lens' exact element={<ProtectedRoutes><Lens /></ProtectedRoutes>} />
          <Route path='/size' exact element={<ProtectedRoutes><LensSize /></ProtectedRoutes>} />
          <Route path='/lens-size-mapping' exact element={<ProtectedRoutes><LenSizeMapping /></ProtectedRoutes>} />
          <Route path='/customers' exact element={<ProtectedRoutes><Customers /></ProtectedRoutes>} />
          <Route path='/coupons' exact element={<ProtectedRoutes><Coupons /></ProtectedRoutes>} />
          <Route path='/special-customers' exact element={<ProtectedRoutes><SpecialCustomers /></ProtectedRoutes>} />
          <Route path='/reports' exact element={<ProtectedRoutes><Reports /></ProtectedRoutes>} />
          <Route path='/blogs' exact element={<ProtectedRoutes><Blogs /></ProtectedRoutes>} />
          <Route path='/taxes' exact element={<ProtectedRoutes><Taxes /></ProtectedRoutes>} />
          <Route path='/bulk-orders' exact element = {<ProtectedRoutes><BulkOrders/></ProtectedRoutes>} />
          {/* <Route path='/filters' exact element={<ProtectedRoutes><Filters /></ProtectedRoutes>} /> */}
          <Route path='/brands' exact element={<ProtectedRoutes><Brands /></ProtectedRoutes>} />
          <Route path='/frames' exact element={<ProtectedRoutes><Frames /></ProtectedRoutes>} />
        </Routes>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
